import React from "react";
import PropTypes from "prop-types";
import {ASpinLoader} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import css from "./EntityIconLoader.module.scss";

export default function EntityIconLoader({small = false, className}) {
  return (
    <ASpinLoader
      data-testid="EntityList-EntityIconLoader"
      variant="spinner"
      size="small"
      className={classNames(className, css.entityIconLoader, {
        [css.entityIconLoaderDefault]: !small,
        [css.entityIconLoaderSmall]: small
      })}
    />
  );
}

EntityIconLoader.propTypes = {
  small: PropTypes.bool,
  className: PropTypes.string
};
